import { EditorContent, useEditor } from "@tiptap/react";
import type { ReactElement } from "react";
import {
  richTextEditorExtensions,
  type RichTextDocument,
} from "../../../../shared/rich-text-document";
import { NOTE_PROSE_CLASSES } from "@/components/v2/rich-text-editor";

/**
 * An Appointment Note as text (NO-467).
 *
 * A separate component rather than `RichTextEditor disabled`: the read-only
 * signal is the ABSENCE of the toolbar, autosave status, and conflict UI, and a
 * disabled editor still renders all three.
 */
export function AppointmentNoteReadOnly({
  document,
}: {
  document: RichTextDocument;
}): ReactElement {
  const editor = useEditor({
    extensions: richTextEditorExtensions,
    content: document,
    editable: false,
    immediatelyRender: false,
  });

  return (
    <section
      aria-label="Appointment Note"
      className="mt-4 flex min-h-0 flex-1 flex-col"
    >
      <h2 className="mb-2 shrink-0 font-sans text-body font-bold text-foreground">
        Appointment Note
      </h2>
      {/* The badge in the header is visual only; focus entering this region
          needs the state announced too. A long note scrolls inside the
          region: the canvas around it does not scroll. */}
      <div
        role="region"
        aria-label="Appointment Note, read-only"
        tabIndex={0}
        className="min-h-0 overflow-y-auto rounded-lg border border-border"
      >
        <EditorContent editor={editor} className={NOTE_PROSE_CLASSES} />
      </div>
    </section>
  );
}
